import { LoadingButton } from "@mui/lab";
import { LoadingButtonProps } from "@mui/lab/LoadingButton/LoadingButton";

type Props = Pick<
  LoadingButtonProps,
  "children" | "loading" | "size" | "disabled" | "onClick" | "variant" | "sx" | "color"
> & {
  formId?: string;
  "data-testid"?: string;
};

const SubmitButton = ({
  children,
  loading,
  disabled,
  size,
  onClick,
  variant = "contained",
  sx,
  color,
  formId,
  "data-testid": dataTestId,
}: Props) => {
  return (
    <LoadingButton
      variant={variant}
      color={color}
      type="submit"
      data-testid={dataTestId || "submit"}
      disabled={disabled}
      size={size}
      loading={loading}
      onClick={onClick}
      sx={sx}
      form={formId}
    >
      {children}
    </LoadingButton>
  );
};

export default SubmitButton;
